<template>
	<v-data-table
		:headers="tableHeaders"
		:items="items"
		:loading="loading"
		:custom-sort="sortItems"
		:footer-props="{
			'items-per-page-options': [50, 100]
		}"
		sort-by="ytd_paid"
		sort-desc
		class="table-stripped">
		<template #item.name="{ item }">
			<Link :href="route('clients.show', item)">{{ item.name }}</Link>
		</template>
		<template #item.last_year_total="{ item }">
			{{ item.last_year_total | money }}
		</template>
		<template #item.last_ytd_total="{ item }">
			{{ item.last_ytd_total | money }}
		</template>
		<template #item.ytd_total="{ item }">
			<span
				v-if="revenueAmount(item) !== null"
				:class="[
					'revenue-change mr-2',
					`revenue-change--${revenueDirection(item)}`,
				]">
				<v-icon size="15" :color="'up' === revenueDirection(item) ? '#16a794' : '#ff6c6c'">
					{{ 'up' === revenueDirection(item) ? 'mdi-arrow-up' : 'mdi-arrow-down' }}
				</v-icon>
				{{ revenueAmount(item) }}%
			</span>
			{{ item.ytd_total | money }}
		</template>
		<template #item.ytd_paid="{ item }">
			{{ item.ytd_paid | money }}
		</template>
		<template #item.ytd_outstanding="{ item }">
			{{ item.ytd_outstanding | money }}
		</template>
		<template #item.created_at="{ item }">
			{{ item.created_at | humanDate }}
		</template>
	</v-data-table>
</template>
<script>

export default {
	components: {},
	props: {
		clients: {
			type: [Array, Object],
			default: () => {},
			required: false
		},
		loading: {
			type: Boolean,
			default: () => false
		},
		year: {
			type: Number,
			default: () => 0
		},
		quarter: {
			type: [Number, null],
			default: () => null
		}
	},
	data () {
		return {
			items: this.clients

		}
	},
	computed: {
		tableHeaders () {
			if (this.clients === undefined) {
				return []
			}
			const thisYearCalc = this.clients.some(client => client.last_ytd_total !== null)

			const headers = [
				{
					text: 'Name',
					align: 'start',
					value: 'name',
					sortable: true
				},
				{
					text: 'Client Since',
					sortable: false,
					value: 'created_at',
					width: '200px'
				},
				{
					text: 'Total Invoiced' + (this.year ? ' (' + (this.year - 1) + (this.quarter !== null ? (' Q' + this.quarter) : '') + ')' : ''),
					sortable: true,
					align: 'right',
					value: 'last_year_total',
					width: '200px',
					class: 'sort-icon-left'
				}
			]

			if (thisYearCalc) {
				headers.push({
					text: 'Total Invoiced YTD' + (this.year
						? ' (' + new Date(
							new Date().getFullYear() - 1,
							new Date().getMonth(),
							new Date().getDate()
						).toLocaleDateString('en-US') + (this.quarter !== null ? (' Q' + this.quarter) : '') + ')'
						: ''),
					sortable: true,
					align: 'right',
					value: 'last_ytd_total',
					width: '220px',
					class: 'sort-icon-left'
				})
			}

			headers.push(
				{
					text: thisYearCalc
						? 'Total Invoiced YTD' + (this.year
							? ' (' + new Date().toLocaleDateString('en-US') + (this.quarter !== null ? (' Q' + this.quarter) : '') + ')'
							: '')
						: 'Total Invoiced' + (this.year ? ' (' + this.year + (this.quarter !== null ? (' Q' + this.quarter) : '') + ')' : ''),
					sortable: true,
					align: 'right',
					value: 'ytd_total',
					width: '220px',
					class: 'sort-icon-left'
				},
				{
					text: 'Total Paid',
					sortable: true,
					align: 'right',
					value: 'ytd_paid',
					width: '137px',
					class: 'sort-icon-left'
				},
				{
					text: 'Total Outstanding',
					sortable: true,
					align: 'right',
					value: 'ytd_outstanding',
					width: '187px',
					class: 'sort-icon-left'
				}
			)

			return headers
		}
	},
	watch: {
		clients () {
			this.items = this.clients
		}
	},
	methods: {
		sortItems (items, sortBy, sortDesc) {
			if (!sortBy.length) {
				return items
			}

			const field = sortBy[0]
			const direction = sortDesc[0] ? -1 : 1

			return [...items].sort((firstItem, secondItem) => {
				const firstValue = firstItem[field]
				const secondValue = secondItem[field]

				if ('name' === field) {
					return direction * this.compareNames(firstValue, secondValue)
				}

				if (firstValue === secondValue) {
					return 0
				}

				return direction * (firstValue > secondValue ? 1 : -1)
			})
		},

		compareNames (firstName, secondName) {
			return String(firstName || '').trim().localeCompare(
				String(secondName || '').trim(),
				undefined,
				{
					sensitivity: 'base',
					numeric: true
				}
			)
		},

		revenueDirection (item) {
			const last_year = item.last_ytd_total ?? item.last_year_total

			return item.ytd_total > last_year ? 'up' : 'down'
		},

		revenueAmount (item) {
			const currentValue = Number(item.ytd_total) || 0
			const previousValue = Number(item.last_ytd_total ?? item.last_year_total) || 0

			if (0 === previousValue || 0 === currentValue || currentValue === previousValue) {
				return null
			}

			const percentage = ((currentValue - previousValue) / Math.abs(previousValue)) * 100
			return Number(Math.round(Math.abs(percentage))).toLocaleString('en-US')
		}
	}
}
</script>
